import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithPopup, signOut } from "firebase/auth";
import { getDoc, setDoc, doc } from "firebase/firestore";
import { auth, db, googleProvider } from "./firebaseConfig";
import Logo from "./assets/images/LOGO with name DARK.png";
import './App.css';






const MainApp = () => {

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        // Look up user doc in Firestore
        const userDocRef = doc(db, "users", currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists() && userDoc.data().approved) {
          // ✅ Only navigate if approved
          navigate("/order");
        } else {
          alert("Your account is not approved yet.");
          await signOut(auth);
        }
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleSignIn = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists() && userDoc.data().approved) {
        navigate("/order");
      } else {
        alert("Your account is not approved yet.");
        await signOut(auth);
      }
    } catch (error) {
      alert("Sign-in failed: " + error.message);
    }
  };

  const handleSignUp = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // ✅ Add required fields for new users
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        approved: false,
        admin: false,
        specialAccess: false,
        store: null,
        role: "unknown"
      });

      alert("Sign-up successful! Please wait for admin approval.");
      await signOut(auth);
    } catch (error) {
      alert("Sign-up failed: " + error.message);
    }
  };


  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        if (userDoc.data().approved) {
          navigate("/order");
        } else {
          alert("Your account is not approved yet.");
          await signOut(auth);
        }
      } else {
        // ✅ New Google user, create their profile
        await setDoc(userDocRef, {
          email: user.email,
          approved: false,
          admin: false,
          specialAccess: false,
          store: null
        });

        alert("Sign-up successful! Please wait for admin approval.");
        await signOut(auth);
      }
    } catch (error) {
      alert("Google Sign-in failed: " + error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-violet-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img src={Logo} alt="Logo" className="h-16" />
        </div>
        <h1 className="text-2xl font-bold text-center text-gray-700 mb-4">Welcome</h1>
        <p className="text-gray-600 text-center mb-6">Sign in or create an account to continue.</p>

        <form
          onSubmit={(e) => {
            e.preventDefault(); // prevent default form submission
            handleSignIn();
          }}
        >
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            className="block w-full px-4 py-2 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-indigo-200"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            className="block w-full px-4 py-2 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-indigo-200"
          />
          <button
            type="submit"
            className="w-full px-4 py-2 mb-4 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 focus:ring focus:ring-indigo-200"
          >
            Sign In
          </button>
        </form>

        <button
          onClick={handleSignUp}
          className="w-full px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:ring focus:ring-indigo-200"
        >
          Sign Up
        </button>


        <div className="flex items-center justify-center my-4">
          <hr className="flex-grow border-gray-300" />
          <p className="mx-4 text-gray-500 text-sm">or</p>
          <hr className="flex-grow border-gray-300" />
        </div>

        <button
          onClick={handleGoogleSignIn}
          className="flex items-center justify-center w-full px-4 py-2 bg-white text-gray-700 border border-gray-300 rounded-lg shadow-sm hover:shadow-md focus:outline-none focus:ring focus:ring-gray-200"
        >
          <div className="flex items-center justify-center w-6 h-6 mr-3">
            {/* Google Icon */}
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 48 48"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              className="w-full h-full"
            >
              <path
                fill="#EA4335"
                d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
              ></path>
              <path
                fill="#4285F4"
                d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
              ></path>
              <path
                fill="#FBBC05"
                d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
              ></path>
              <path
                fill="#34A853"
                d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
              ></path>
              <path fill="none" d="M0 0h48v48H0z"></path>
            </svg>
          </div>
          <span className="text-sm font-medium">Continue with Google</span>
        </button>
      </div>
    </div>
  );
};

export default MainApp;